// extracted by mini-css-extract-plugin
export default {"modal__title":"BannerFormModal_modal__title__TM+9m","modal__body":"BannerFormModal_modal__body__sdazw"};